import $ from '@ali/tarzan-zepto';
import BaseUI from '../../../component/baseui/index.js';
import tpl from './tpl.html';
import EventBus from '../../context/eventbus.js';
import util from '../../../lib/util.js';
import './style.scss';

const clickType = util.isPC() ? 'click' : 'tap';

export default function robot(data) {
  data.buttons = this.appConfig.get('recommend').list || [];
  data.buttonOrder = this.util.lang.get('ORDER:STATUS');
  data.buttonCancel = this.util.lang.get('CANCEL:ITEM');
  data.qa = this.util.lang.get('ROBOT:WELCOME');
  data.liveagent = this.util.lang.get('ROBOT:LIVEAGENT');
  data.showLiveAgent = this.param.showLiveAgent;
  const param = {
    name: 'welcomemsg',
    mid: data.mid,
    isFollow: data.isFollow,
    content: tpl.render({ data }),
  };
  const $node = $(BaseUI.msg(param));

  $node.find('.m-chatpanel-option-button').on(clickType, (ev) => {
    const $target = $(ev.currentTarget);
    const text = $target.attr('data-value');
    this.view.footer.submit(text);
  });

  $node.find('.welcomemsg-liveagent').on(clickType, () => {
    this.liveAgent.entry = 'welcomeCard';
    EventBus.emit('liveAgent', { entry: 'welcomeCard', type: 'click', chatUuid: '', intent: '' });
  });

  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/welcomemsg/index.js